import script from "./EditProduct.vue?vue&type=script&setup=true&lang=js"
export * from "./EditProduct.vue?vue&type=script&setup=true&lang=js"

import "./EditProduct.vue?vue&type=style&index=0&id=4d792176&scoped=true&lang=css"

import exportComponent from "C:\\ClusterTrade\\NXM_CLUSTERTRADE\\nxm_clustertrade_front\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4d792176"]])

export default __exports__